import * as React from 'react'

import { Box, Tag } from '@factorialco/deprecated-design-system'

import { tagColor, tagLabel } from 'modules/reviews/lib/tagConstants'

interface Props {
  status: string
}

export const StatusTag = ({ status }: Props) => {
  return (
    <Box>
      <Tag leftItem="circle" inline capitalize showCircle type={tagColor(status as string)}>
        {tagLabel(status as string)}
      </Tag>
    </Box>
  )
}
